import React,{useEffect, useState, useContext} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { GlobalContext } from '../../Contexts/GlobalContext';


export default function PaynetSuccess (props) {
    const globalContext = useContext(GlobalContext);
    const classes = useStyles();

    useEffect(
        () => {
            globalContext.dispatchMethod(
                {
                    type: 'SET_MENU_LOCATION',
                    value: {
                        a: '0',
                        b: '0'
                    },
                }
            )
        }, []
    )

    return (
        <div className={classes.root}>
            Aboneliğiniz başarı ile gerçekleşti.
        </div>
    )
}

const useStyles = makeStyles({
    root: {"marginTop":"50px","textAlign":"center","fontSize":"1.4rem"},
});